(function () {
  if (!window.EmblaCarousel) {
    console.error('EmblaCarousel not loaded'); return;
  }

  /* ----- DOM refs ----- */
  const root = document.querySelector('.bds-sticky');
  const viewport = root.querySelector('.bds-sticky__slider-wrap');  // Embla viewport
  const slides = Array.from(root.querySelectorAll('.bds-sticky__slide'));
  const dotsWrap = root.querySelector('.bds-sticky__dots');
  const nextBtn = root.querySelector('.bds-sticky__next');
  const prevBtn = root.querySelector('.bds-sticky__prev');
  const canvas = root.querySelector('.bds-sticky__gradient-canvas');
  const animator = new GradientAnimator(canvas);


  /* ----- Embla init (horizontal) ----- */
  const embla = EmblaCarousel(viewport, {
    loop: false,
    align: 'start',
    containScroll: 'trimSnaps'
  });

  /* ----- Initial state ----- */
  animator.setGradient(slides[0].dataset.gradient, 0);

  /* ----- Slide change → update UI ----- */
  const onSelect = () => {
    const i = embla.selectedScrollSnap();
    animator.setGradient(slides[i].dataset.gradient, 800);
  };
  embla.on('select', onSelect);
  onSelect();

  const removeDotBtnsAndClickHandlers = addDotBtnsAndClickHandlers(
    embla,
    dotsWrap
  )
  const removePrevNextBtnsClickHandlers = addPrevNextBtnsClickHandlers(
    embla,
    prevBtn,
    nextBtn
  )

})();
